export default "__VITE_ASSET__b500cdd8__"